import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { ClientSinglePackage, FullClientPackage, PackageEvent } from '../types';

interface LoadAvailablePackageParams {
  client?: string;
  currency?: string;
}

export const packageLoaders = getLoaders({
  availablePackages: {
    load: async (payload?: LoadAvailablePackageParams): Promise<FullClientPackage[]> => {
      return executeApiCall({
        path: '/invoice/packages/available',

        method: 'get',

        payload,
      });
    },
  },

  packageByStatus: {
    load: async (payload: { status: string }): Promise<FullClientPackage[]> => {
      return executeApiCall({
        path: '/invoice/packages/by-status',

        method: 'get',

        payload,
      });
    },
  },

  findPackage: {
    load: async ({ id }: { id: string }): Promise<ClientSinglePackage> => {
      return executeApiCall({
        path: `/invoice/packages/${id}`,

        method: 'get',
      });
    },
  },

  packageEvents: {
    load: async ({ packageId }: { packageId: string }): Promise<PackageEvent[]> => {
      return executeApiCall({
        path: `/invoice/packages/${packageId}/events`,

        method: 'get',
      });
    },
  },
});
